import { takeEvery } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';
import Cookies from 'cookies-js';
import { closeModal } from './Modal';
import createWebAPI from './WebAPI';

const LOAD_BALANCE_SAGA = 'user-dashboard/profile/LOAD_BALANCE';
export const loadBalance = () => ({ type: LOAD_BALANCE_SAGA });

const LOAD_BALANCE_RESULT = 'user-dashboard/profile/LOAD_BALANCE_RESULT';
export const loadBalanceResult = result => ({ type: LOAD_BALANCE_RESULT, result });

const SET_BALANCE_LOADED = 'user-dashboard/profile/SET_BALANCE_LOADED';
export const setBalanceLoaded = value => ({ type: SET_BALANCE_LOADED, value });

const LOAD_CARDS_SAGA = 'user-dashboard/profile/LOAD_CARDS_SAGA';
export const loadCards = () => ({ type: LOAD_CARDS_SAGA });

const LOAD_CARDS_RESULT = 'user-dashboard/profile/LOAD_CARDS_RESULT';
export const loadCardsResult = result => ({ type: LOAD_CARDS_RESULT, result });

const SET_CARDS_LOADED = 'user-dashboard/profile/SET_CARDS_LOADED';
export const setCardsLoaded = value => ({ type: SET_CARDS_LOADED, value });

const DELETE_CARD = 'user-dashboard/DELETE_CARD';
export const deleteCard = card => ({ type: DELETE_CARD, card });

const DO_DELETE_CARD = 'user-dashboard/DO_DELETE_CARD';
export const doDeleteCard = (result) => ({ type: DO_DELETE_CARD, result });

const REMOVE_FROM_DELETE_CARD = 'user-dashboard/REMOVE_FROM_DELETE_CARD';
export const removeFromDeleteCard = () => ({ type: REMOVE_FROM_DELETE_CARD });

const ADD_NOTIFICATION = 'user-dashboard/ADD_NOTIFICATION';
export const addNotification = (value) => ({ type: ADD_NOTIFICATION, value });

const REMOVE_NOTIFICATION = 'user-dashboard/REMOVE_NOTIFICATION';
export const removeNotification = (value) => ({ type: REMOVE_NOTIFICATION, value });

const ADD_UNDOABLE_ACTION = 'user-dashboard/ADD_UNDOABLE_ACTION';
export const addUndoableAction = (value) => ({ type: ADD_UNDOABLE_ACTION, value });

const initialState = {
  balance: {},
  balanceLoaded: false,
  cards: {},
  cardsLoaded: false,
  cardToDelete: [],
  notifications: [],
  profile: null,
  profileLoaded: false,
  isAuthenticated: !!Cookies.get('TESCookieUser'),
  hasAccessForReviews: !!Cookies.get('TESReviewUser'),
};

const webApi = createWebAPI();

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_BALANCE_RESULT: {
      return { ...state, balance: action.result };
    }
    case SET_BALANCE_LOADED: {
      return { ...state, balanceLoaded: action.value };
    }
    case LOAD_CARDS_RESULT: {
      return { ...state, cards: action.result };
    }
    case SET_CARDS_LOADED: {
      return { ...state, cardsLoaded: action.value };
    }
    case DELETE_CARD: {
      return { ...state, cardToDelete: [action.card] };
    }
    case REMOVE_FROM_DELETE_CARD: {
      return { ...state, cardToDelete: [] };
    }
    case ADD_NOTIFICATION: {
      return { ...state, notifications: [action.value].concat(state.notifications) };
    }
    case REMOVE_NOTIFICATION: {
      return { ...state, notifications: state.notifications.filter(notification => notification.notificationId !== action.value.notificationId) };
    }
    default:
      return state;
  }
}

export function sagas({ store }) {
  function* loadBalanceSaga() {
    try {
      const loaded = yield select((state) => state.profileModule.balanceLoaded);
      if (loaded) return;
      const result = yield call(() => webApi.profile.getBalance({}));
      yield put(loadBalanceResult(result));
      yield put(setBalanceLoaded(true));
    } catch (ex) {
      // eslint-disable-next-line no-console
      console.error('Exception in load balance saga', ex);
    }
  }

  function* loadCardsSaga() {
    try {
      const loaded = yield select((state) => state.profileModule.cardsLoaded);
      if (loaded) return;
      const result = yield call(() => webApi.profile.getCards({}));
      yield put(loadCardsResult(result));
      yield put(setCardsLoaded(true));
    } catch (ex) {
      // eslint-disable-next-line no-console
      console.error('Exception in load cards saga', ex);
    }
  }

  function* doDeleteCardSaga() {
    try {
      yield put(closeModal());
      yield call(() => webApi.profile.deleteCard());
      yield put(removeFromDeleteCard());
      yield put(loadCardsResult({}));
      yield put(setCardsLoaded(false));
    } catch (ex) {
      // eslint-disable-next-line no-console
      console.error('Exception in delete card saga', ex);
    }
  }

  function* addUndoableActionSaga(action) {
    try {
      const notification = {
        isUndone: false,
        show: true,
        notificationId: Math.random(),
        closable: true,
        defaultShow: true,
        blockUI: false,
        autoHideTimeout: 3000,
        autoHide: true,
        children: [action.value.message],
        onClose: () => {
          if (!notification.isUndone) {
            action.value.action();
            notification.show = false;
            store.dispatch(removeNotification(notification));
          }
        },
        undoAction: () => {
          notification.isUndone = true;
          notification.show = false;
          store.dispatch(removeNotification(notification));
        },
      };
      yield put(addNotification(notification));
    } catch (ex) {
      // eslint-disable-next-line no-console
      console.error('Exception in addUndoableActionSaga', ex);
    }
  }

  return {
    * watchLoadBalance() { yield* takeEvery(LOAD_BALANCE_SAGA, loadBalanceSaga); },
    * watchLoadCards() { yield* takeEvery(LOAD_CARDS_SAGA, loadCardsSaga); },
    * watchDoDeleteCard() { yield* takeEvery(DO_DELETE_CARD, doDeleteCardSaga); },
    * watchAddUndoableAction() { yield* takeEvery(ADD_UNDOABLE_ACTION, addUndoableActionSaga); },
  };
}
